<!-- Cabeçalho aprimorado da prévia JSON com status de validação e ações -->
<div style="display:flex; gap:8px; align-items:center; margin-bottom:8px; flex-wrap: wrap;">
  <!-- Botão de alternar modo de edição -->
  <button nz-button [nzType]="isEditMode ? 'primary' : 'default'" nzSize="small" (click)="toggleEditMode()">
    <nz-icon [nzType]="isEditMode ? 'eye' : 'edit'" nzTheme="outline"></nz-icon>
    {{ isEditMode ? ('builderScreen.jsonPreview.viewMode' |translateTA) : ('builderScreen.jsonPreview.editMode' |translateTA) }}
  </button>

  <!-- Botões de ação para modo de edição -->
  <ng-container *ngIf="isEditMode">
    <!-- Toggle para aplicação em tempo real -->
    <nz-switch 
      [(ngModel)]="realTimeSync" 
      [nzSize]="'small'"
      [nzCheckedChildren]="'Tempo Real'"
      [nzUnCheckedChildren]="'Manual'"
      nz-tooltip
      [nzTooltipTitle]="'Aplicar mudanças automaticamente enquanto digita'">
    </nz-switch>
    
    <!-- Botão para carregar exemplo -->
    <button nz-button nzType="dashed" nzSize="small" (click)="loadSampleJson()">
      <nz-icon nzType="experiment" nzTheme="outline"></nz-icon>
      Exemplo
    </button>
    
    <button nz-button nzType="primary" nzSize="small" (click)="saveJsonChanges()" [disabled]="!isValid">
      <nz-icon nzType="check" nzTheme="outline"></nz-icon>
      {{ 'builderScreen.jsonPreview.saveChanges' |translateTA }}
    </button>
    
    <button nz-button nzType="default" nzSize="small" (click)="cancelJsonChanges()">
      <nz-icon nzType="close" nzTheme="outline"></nz-icon>
      {{ 'builderScreen.jsonPreview.cancel' |translateTA }}
    </button>
  </ng-container>

  <!-- Botões tradicionais (visíveis apenas no modo visualização) -->
  <ng-container *ngIf="!isEditMode">
    <!-- Botão de copiar existente -->
    <button nz-button nzType="default" nzSize="small" (click)="copy()">
      <nz-icon nzType="copy" nzTheme="outline"></nz-icon>
      {{ 'builderScreen.json.copy' |translateTA }}
    </button>
    
    <!-- Botão de exportar aprimorado -->
    <button nz-button nzType="primary" nzSize="small" (click)="exportJson()" [disabled]="!isValid">
      <nz-icon nzType="download" nzTheme="outline"></nz-icon>
      {{ 'builderScreen.jsonPreview.export' |translateTA }}
    </button>
    
    <!-- Botão de salvar no servidor aprimorado -->
    <button nz-button nzType="dashed" nzSize="small" (click)="saveToServer()" [disabled]="!isValid" nz-tooltip [nzTooltipTitle]="'builderScreen.jsonPreview.saveToServer' |translateTA">
      <nz-icon nzType="cloud-upload" nzTheme="outline"></nz-icon>
      {{ 'builderScreen.jsonPreview.save' |translateTA }}
    </button>
  </ng-container>
  
  <!-- Status de validação aprimorado -->
  <nz-tag [nzColor]="isValid ? 'success' : 'error'" *ngIf="jsonText">
    <nz-icon [nzType]="isValid ? 'check-circle' : 'close-circle'" nzTheme="outline"></nz-icon>
    {{ isValid ? ('builderScreen.jsonPreview.valid' |translateTA) : ('builderScreen.jsonPreview.invalid' |translateTA) }}
  </nz-tag>
  
  <!-- Informações dos Tipos de Ação -->
  <div *ngIf="actionTypes$ | async as actionTypes" style="display: flex; gap: 4px; align-items: center;">
    <span *ngIf="actionTypes.length > 0" style="font-size: 12px; color: #666;">
      {{ 'builderScreen.jsonPreview.actions' |translateTA }}:
    </span>
    <nz-tag *ngFor="let actionType of actionTypes" [nzColor]="getActionTypeColor(actionType)" nzSize="small">
      <nz-icon [nzType]="getActionTypeIcon(actionType)" nzTheme="outline"></nz-icon>
      {{ ('builderScreen.button.actionType.' + actionType) |translateTA }}
    </nz-tag>
  </div>
  
  <!-- Botão de alternar aprimorado com melhor UX -->
  <button nz-button nzType="text" nzSize="small" (click)="toggle()" class="toggle-btn">
    <nz-icon [nzType]="collapsed ? 'down' : 'up'" nzTheme="outline"></nz-icon>
    {{ collapsed ? ('builderScreen.jsonPreview.expand' |translateTA) : ('builderScreen.jsonPreview.collapse' |translateTA) }}
  </button>
  
  <!-- Indicador de tamanho do JSON -->
  <nz-tag *ngIf="!collapsed && jsonText" nzSize="small" [nzColor]="'default'">
    {{ getJsonSize() }} {{ 'builderScreen.jsonPreview.lines' |translateTA }}
  </nz-tag>
</div>

<!-- Exibição aprimorada de erro de validação -->
<div *ngIf="!isValid && !collapsed && validationError" style="margin-bottom:8px;">
  <nz-alert 
    nzType="error" 
    [nzMessage]="'builderScreen.jsonPreview.validationError' |translateTA"
    [nzDescription]="validationError"
    nzShowIcon
    nzCloseable>
  </nz-alert>
</div>

<!-- Conteúdo principal: Editor ou Preview -->
<div *ngIf="!collapsed">
  <!-- Modo de Edição: Editor JSON -->
  <div *ngIf="isEditMode" class="json-editor-container">
    <app-json-editor-beta
      #jsonEditor
      [jsonData]="editableJsonData"
      [readOnly]="false"
      [height]="'400px'"
      [showValidation]="true"
      [autoFormat]="true"
      (jsonChange)="onJsonEditorChange($event)"
      (validationChange)="onJsonValidationChange($event)"
      (editorReady)="onEditorReady($event)">
    </app-json-editor-beta>
  </div>

  <!-- Modo de Visualização: Preview tradicional -->
  <div *ngIf="!isEditMode" class="json-preview" [class.error]="!isValid">
    <div [innerHTML]="highlightedJson || jsonText" class="json-content"></div>
  </div>
</div>


